import React from 'react';
import { Hero } from './components/Hero';
import { Hook } from './components/Hook';
import { PainAgitation } from './components/PainAgitation';
import { Reveal } from './components/Reveal';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalClose } from './components/FinalClose';
import { StickyCta } from './components/StickyCta';
export function App() {
  return <div className="w-full bg-ivory" data-id="element-0" data-mp="2rikrdguv4vgt">
      <Hero data-id="element-1" data-mp="2mmlvz9b4ad6w" />
      <main data-id="element-2" data-mp="2mn5ash5h0lgp">
        <Hook data-id="element-3" data-mp="2mndna7xolord" />
        <PainAgitation data-id="element-4" data-mp="2mjpx9irg3khe" />
        <Reveal data-id="element-5" data-mp="31agnimde2bie" />
        <ValueStack data-id="element-6" data-mp="31aysc7e49y1x" />
        <Guarantee data-id="element-7" data-mp="31bi9hlvy0iew" />
        <Faq data-id="element-8" data-mp="31c1igd3m7wgs" />
        <FinalClose data-id="element-9" data-mp="31cjnnz899l0u" />
      </main>
      <footer className="w-full bg-ivory" data-id="element-10" data-mp="2wjgq7g0cxrfd">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-6 py-10 pb-28 font-sans text-xs text-muted sm:flex-row sm:items-center sm:justify-between lg:px-10" data-id="element-11" data-mp="2wip5j08ate3v">
          <p data-id="element-12" data-mp="23u9t8lgjx9w8">© 2026 Wedding Bliss &amp; Fun System™. Producto digital de descarga inmediata.</p>
          <p data-id="element-13" data-mp="3ikqytzf4l45q">Garantía de 7 días · Soporte por WhatsApp</p>
        </div>
      </footer>
      <StickyCta data-id="element-14" data-mp="3ml13n8r6loj0" />
    </div>;
}